const user = {
	isAuthorized: false,
	email: '',
	isLegalFlow: true,
	isOnlyLegalFlow: false,
	flow_tag: '',
	flow_type: '2',
	imageFile: '',
	cartoonifyImage: '',
	filterType: '',
	cardToken: '',
	paypalToken: '',
	bill: false,
	unsubscribeBill: false,
	confirmationEmail: false,
	error: '',
	fbp: '',
	fbc: '',
	firstUpsell: false,
	secondUpsell: false,
	thirdUpsell: false,
	fourthUpsell: false,
	discount: '',
	unsubscribeReason: '',
	isUnsubscribeShown: false,
	totalPrice: '',
	offerTime: 600,
	isRedirectingToLegal: false,
	countryCode: '',
	productId: '',
	purchaseType: '',
	initialPrice: '',
}

export default user
